import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Button from 'primevue/button';
import DefaultInput from '../components/DefaultInput.vue';
import PasswordInput from '../components/PasswordInput.vue';

import { useLogin } from '../composables/useLogin';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const { handleLogin, form, errors, isPending } = useLogin();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "text-bluegray-600 space-y-4 text-center text-sm font-normal",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleLogin) && _unref(handleLogin)(...args)), ["prevent"]))
  }, [
    _createVNode(DefaultInput, {
      modelValue: _unref(form).email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
      size: "small",
      error: _unref(errors).email
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode(" Adres e-mail ")
      ])),
      _: 1
    }, 8, ["modelValue", "error"]),
    _createVNode(PasswordInput, {
      modelValue: _unref(form).password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
      error: _unref(errors).password
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode(" Hasło ")
      ])),
      _: 1
    }, 8, ["modelValue", "error"]),
    _createVNode(_unref(Button), {
      class: "mx-auto",
      type: "submit",
      rounded: "",
      disabled: Object.keys(_unref(errors)).length > 0 || _unref(isPending)
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode(" Zaloguj się ")
      ])),
      _: 1
    }, 8, ["disabled"])
  ], 32))
}
}

})